import {createContext,useContext} from 'solid-js';

const PageDetailsContext = createContext();

interface IPageDetailsContent {
	pageName: string;
	setPageName: (name:string)=>void;
	setSettingsPageName: (name:string)=>void,
	imageFolder: string;
	setImageFolder: (name:string)=>void,
}

export function PageDetailsProvider(P:{children} & IPageDetailsContent)
{
	return (
		<PageDetailsContext.Provider value={P}>
			{P.children}
		</PageDetailsContext.Provider>
	);
}

export function initPageDetails(pageName:string,settingsPageName:string,imageFolder:string|null=null)
{
	const details = useContext(PageDetailsContext);
	details.setPageName(pageName);
	details.setSettingsPageName(settingsPageName);
	details.setImageFolder(imageFolder);
}

export function usePageDetails():IPageDetailsContent
{
	return useContext(PageDetailsContext);
}

